// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
  font-family: inherit;
}

.completed-program-dialog {
  display: flex;
  max-height: 92vh;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: var(--ca-surface, #fff);
}

.dialog-header {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.4rem 1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fff, #fbfcff);
}

.dialog-heading {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.85rem;
}

.heading-icon,
.section-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  border: 1px solid var(--ca-border-light, #e9edf3);
}

.heading-icon {
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.8rem;
  font-size: 1.2rem;
}

.heading-copy {
  min-width: 0;
}

.eyebrow {
  margin: 0 0 0.25rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.dialog-header h2 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.25rem;
  font-weight: 750;
  line-height: 1.3;
}

.dialog-subtitle {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.8rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.close-button {
  display: grid;
  width: 2.3rem;
  height: 2.3rem;
  flex: 0 0 2.3rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 0.65rem;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  cursor: pointer;
}

.close-button:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.close-button:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}

.dialog-meta {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 0.45rem 1rem;
  padding: 0.7rem 1.4rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-bg-secondary, #eef2f8);
  font-size: 0.72rem;
}

.dialog-meta span {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 0.4rem;
}

.dialog-meta strong {
  color: var(--ca-text-secondary, #4b5870);
  white-space: nowrap;
}

.dialog-meta code {
  color: var(--ca-text-primary, #172033);
  overflow-wrap: anywhere;
}

.dialog-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem 1.3rem 1.25rem;
}

.detail-section {
  margin-bottom: 1rem;
  padding: 1rem 1.05rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 0.8rem;
}

.section-icon {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.65rem;
  font-size: 1rem;
}

.implementation-icon {
  color: #6b4eb2;
  background: #f2edff;
}

.verification-icon {
  color: var(--ca-success, #198754);
  background: var(--ca-success-bg, #eaf7f0);
}

.section-heading > div {
  min-width: 0;
  flex: 1;
}

.section-heading h3 {
  margin: 0 0 0.15rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
  font-weight: 750;
}

.section-heading p {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.73rem;
  line-height: 1.45;
}

.status-badge {
  max-width: 9rem;
  padding: 0.32rem 0.6rem;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  overflow-wrap: anywhere;
  text-align: center;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 0.9rem;
  margin: 0;
}

.detail-item {
  min-width: 0;
  padding: 0.65rem 0;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.detail-item:nth-last-child(-n+2) {
  border-bottom: 0;
}

.detail-item-wide {
  grid-column: 1/-1;
}

.detail-item-wide:nth-last-child(-n+2) {
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.detail-item dt {
  margin-bottom: 0.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
  font-weight: 650;
}

.detail-item dd {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.detail-item .break-value {
  word-break: break-word;
  font-weight: 500;
}

.empty-section {
  margin: 0.2rem 0 0;
  padding: 0.75rem;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
}

.dialog-state {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
  text-align: center;
}

.dialog-state strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
}

.dialog-state p {
  max-width: 28rem;
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.82rem;
  line-height: 1.55;
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: completed-view-spin 0.8s linear infinite;
}

.state-icon {
  display: grid;
  width: 2.8rem;
  height: 2.8rem;
  place-items: center;
  border-radius: 0.8rem;
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.2rem;
}

.dialog-state .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.dialog-footer {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 0.8rem 1.3rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface, #fff);
}

.dialog-footer .btn {
  min-width: 6.5rem;
}

.btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.btn-secondary {
  border-color: var(--ca-border, #dfe4ec);
  background: #fff;
  color: var(--ca-primary, #0e2e80);
}

@keyframes completed-view-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 600px) {
  .dialog-header {
    padding: 1rem;
  }
  .dialog-meta {
    flex-direction: column;
    padding: 0.65rem 1rem;
  }
  .dialog-body {
    padding: 0.75rem;
  }
  .detail-section {
    padding: 0.85rem;
  }
  .details-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-item:nth-last-child(-n+2) {
    border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  }
  .detail-item:last-child {
    border-bottom: 0;
  }
  .detail-item-wide {
    grid-column: auto;
  }
  .section-heading {
    align-items: flex-start;
  }
  .section-heading p {
    max-width: 20rem;
  }
  .status-badge {
    max-width: 7rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .loading-spinner {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/data-protection-program/data-protection-program-completed-view/data-protection-program-completed-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;EACA,wDAAA;EACA,kDAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iCAAA;EACA,6CAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EAAgB,YAAA;AAEhB;;AADA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAIF;;AADA;EACE,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,SAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;AAIF;;AADA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,sBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;AAIF;;AAFA;EACE,wCAAA;EACA,6CAAA;EACA,iCAAA;AAKF;;AAHA;EAA8B,mDAAA;EAAqD,mBAAA;AAQnF;;AANA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,wDAAA;EACA,2CAAA;EACA,kBAAA;AASF;;AAPA;EAAoB,aAAA;EAAe,YAAA;EAAc,qBAAA;EAAuB,WAAA;AAcxE;;AAbA;EAAsB,wCAAA;EAA0C,mBAAA;AAkBhE;;AAjBA;EAAoB,sCAAA;EAAwC,uBAAA;AAsB5D;;AApBA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AAuBF;;AApBA;EACE,mBAAA;EACA,qBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;AAuBF;;AArBA;EAA6B,gBAAA;AAyB7B;;AAxBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA2BF;;AAzBA;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AA4BF;;AA1BA;EAAuB,cAAA;EAAgB,mBAAA;AA+BvC;;AA9BA;EAAqB,iCAAA;EAAmC,yCAAA;AAmCxD;;AAlCA;EAAyB,YAAA;EAAc,OAAA;AAuCvC;;AAtCA;EACE,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAyCF;;AAvCA;EAAqB,SAAA;EAAW,uCAAA;EAAyC,kBAAA;EAAmB,iBAAA;AA8C5F;;AA7CA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAgDF;;AA7CA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;EACA,SAAA;AAgDF;;AA9CA;EAAe,YAAA;EAAc,kBAAA;EAAmB,wDAAA;AAoDhD;;AAnDA;EAAsC,gBAAA;AAuDtC;;AAtDA;EAAoB,iBAAA;AA0DpB;;AAzDA;EAA2C,wDAAA;AA6D3C;;AA5DA;EAAkB,sBAAA;EAAuB,uCAAA;EAAyC,iBAAA;EAAkB,gBAAA;AAmEpG;;AAlEA;EAAkB,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EAAkB,qBAAA;EAAuB,uBAAA;AA4EnJ;;AA3EA;EAA4B,sBAAA;EAAwB,gBAAA;AAgFpD;;AA/EA;EAAiB,kBAAA;EAAmB,gBAAA;EAAiB,uCAAA;EAAyC,2CAAA;EAA6C,wCAAA;EAA0C,iBAAA;AAwFrL;;AAtFA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,kBAAA;AAyFF;;AAvFA;EAAuB,sCAAA;EAAwC,kBAAA;AA4F/D;;AA3FA;EAAkB,gBAAA;EAAkB,SAAA;EAAW,uCAAA;EAAyC,kBAAA;EAAmB,iBAAA;AAmG3G;;AAlGA;EAAmB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,2CAAA;EAA6C,4CAAA;EAA8C,kBAAA;EAAoB,mDAAA;AA4GpL;;AA3GA;EAAc,aAAA;EAAe,aAAA;EAAe,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;EAAsB,wCAAA;EAA0C,gCAAA;EAAkC,iBAAA;AAsHnL;;AArHA;EAAqB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;AA2HhE;;AAzHA;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,qDAAA;EACA,mCAAA;AA4HF;;AA1HA;EAAsB,iBAAA;AA8HtB;;AA7HA;EAAe,wCAAA;EAA0C,sCAAA;EAAwC,WAAA;AAmIjG;;AAlIA;EAAqB,6CAAA;EAA+C,2CAAA;AAuIpE;;AAtIA;EAAiB,uCAAA;EAAyC,gBAAA;EAAkB,iCAAA;AA4I5E;;AA1IA;EAAiC;IAAK,yBAAA;EA+IpC;AACF;AA9IA;EACE;IAAiB,aAAA;EAiJjB;EAhJA;IAAe,sBAAA;IAAwB,qBAAA;EAoJvC;EAnJA;IAAe,gBAAA;EAsJf;EArJA;IAAkB,gBAAA;EAwJlB;EAvJA;IAAgB,qCAAA;EA0JhB;EAzJA;IAAsC,wDAAA;EA4JtC;EA3JA;IAA0B,gBAAA;EA8J1B;EA7JA;IAAoB,iBAAA;EAgKpB;EA/JA;IAAmB,uBAAA;EAkKnB;EAjKA;IAAqB,gBAAA;EAoKrB;EAnKA;IAAgB,eAAA;EAsKhB;AACF;AApKA;EACE;IAAmB,qCAAA;IAAsC,uCAAA;EAwKzD;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n  font-family: inherit;\n}\n\n.completed-program-dialog {\n  display: flex;\n  max-height: 92vh;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n}\n\n.dialog-header {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.4rem 1rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(180deg, #fff, #fbfcff);\n}\n\n.dialog-heading {\n  display: flex;\n  min-width: 0;\n  align-items: flex-start;\n  gap: .85rem;\n}\n\n.heading-icon,\n.section-icon {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.heading-icon {\n  width: 2.8rem;\n  height: 2.8rem;\n  border-radius: .8rem;\n  font-size: 1.2rem;\n}\n\n.heading-copy { min-width: 0; }\n.eyebrow {\n  margin: 0 0 .25rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: .65rem;\n  font-weight: 800;\n  letter-spacing: .12em;\n}\n\n.dialog-header h2 {\n  margin: 0 0 .25rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.25rem;\n  font-weight: 750;\n  line-height: 1.3;\n}\n\n.dialog-subtitle {\n  margin: 0;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: .8rem;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.close-button {\n  display: grid;\n  width: 2.3rem;\n  height: 2.3rem;\n  flex: 0 0 2.3rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: .65rem;\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n  cursor: pointer;\n}\n.close-button:hover {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n.close-button:focus-visible { outline: 2px solid var(--ca-primary-light, #2850ad); outline-offset: 2px; }\n\n.dialog-meta {\n  display: flex;\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n  gap: .45rem 1rem;\n  padding: .7rem 1.4rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-bg-secondary, #eef2f8);\n  font-size: .72rem;\n}\n.dialog-meta span { display: flex; min-width: 0; align-items: baseline; gap: .4rem; }\n.dialog-meta strong { color: var(--ca-text-secondary, #4b5870); white-space: nowrap; }\n.dialog-meta code { color: var(--ca-text-primary, #172033); overflow-wrap: anywhere; }\n\n.dialog-body {\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 1rem 1.3rem 1.25rem;\n}\n\n.detail-section {\n  margin-bottom: 1rem;\n  padding: 1rem 1.05rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n}\n.detail-section:last-child { margin-bottom: 0; }\n.section-heading {\n  display: flex;\n  align-items: center;\n  gap: .7rem;\n  margin-bottom: .8rem;\n}\n.section-icon {\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: .65rem;\n  font-size: 1rem;\n}\n.implementation-icon { color: #6b4eb2; background: #f2edff; }\n.verification-icon { color: var(--ca-success, #198754); background: var(--ca-success-bg, #eaf7f0); }\n.section-heading > div { min-width: 0; flex: 1; }\n.section-heading h3 {\n  margin: 0 0 .15rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: .95rem;\n  font-weight: 750;\n}\n.section-heading p { margin: 0; color: var(--ca-text-tertiary, #6f7b91); font-size: .73rem; line-height: 1.45; }\n.status-badge {\n  max-width: 9rem;\n  padding: .32rem .6rem;\n  border-radius: 999px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: .66rem;\n  font-weight: 800;\n  letter-spacing: .02em;\n  overflow-wrap: anywhere;\n  text-align: center;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 .9rem;\n  margin: 0;\n}\n.detail-item { min-width: 0; padding: .65rem 0; border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n.detail-item:nth-last-child(-n + 2) { border-bottom: 0; }\n.detail-item-wide { grid-column: 1 / -1; }\n.detail-item-wide:nth-last-child(-n + 2) { border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n.detail-item dt { margin-bottom: .25rem; color: var(--ca-text-tertiary, #6f7b91); font-size: .7rem; font-weight: 650; }\n.detail-item dd { margin: 0; color: var(--ca-text-primary, #172033); font-size: .82rem; font-weight: 600; line-height: 1.5; white-space: pre-wrap; overflow-wrap: anywhere; }\n.detail-item .break-value { word-break: break-word; font-weight: 500; }\n.empty-section { margin: .2rem 0 0; padding: .75rem; border-radius: var(--ca-radius-sm, 6px); background: var(--ca-bg-secondary, #eef2f8); color: var(--ca-text-secondary, #4b5870); font-size: .8rem; }\n\n.dialog-state {\n  display: flex;\n  min-height: 15rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: .65rem;\n  padding: 1.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  text-align: center;\n}\n.dialog-state strong { color: var(--ca-text-primary, #172033); font-size: .95rem; }\n.dialog-state p { max-width: 28rem; margin: 0; color: var(--ca-text-tertiary, #6f7b91); font-size: .82rem; line-height: 1.55; }\n.loading-spinner { display: inline-block; width: 2rem; height: 2rem; border: 3px solid var(--ca-border, #dfe4ec); border-top-color: var(--ca-primary, #0e2e80); border-radius: 50%; animation: completed-view-spin .8s linear infinite; }\n.state-icon { display: grid; width: 2.8rem; height: 2.8rem; place-items: center; border-radius: .8rem; background: var(--ca-danger-bg, #fdecef); color: var(--ca-danger, #dc3545); font-size: 1.2rem; }\n.dialog-state .btn { display: inline-flex; align-items: center; gap: .45rem; }\n\n.dialog-footer {\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  padding: .8rem 1.3rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface, #fff);\n}\n.dialog-footer .btn { min-width: 6.5rem; }\n.btn-primary { border-color: var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); color: #fff; }\n.btn-primary:hover { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); }\n.btn-secondary { border-color: var(--ca-border, #dfe4ec); background: #fff; color: var(--ca-primary, #0e2e80); }\n\n@keyframes completed-view-spin { to { transform: rotate(360deg); } }\n\n@media (max-width: 600px) {\n  .dialog-header { padding: 1rem; }\n  .dialog-meta { flex-direction: column; padding: .65rem 1rem; }\n  .dialog-body { padding: .75rem; }\n  .detail-section { padding: .85rem; }\n  .details-grid { grid-template-columns: minmax(0, 1fr); }\n  .detail-item:nth-last-child(-n + 2) { border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n  .detail-item:last-child { border-bottom: 0; }\n  .detail-item-wide { grid-column: auto; }\n  .section-heading { align-items: flex-start; }\n  .section-heading p { max-width: 20rem; }\n  .status-badge { max-width: 7rem; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .loading-spinner { animation-duration: .01ms !important; animation-iteration-count: 1 !important; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
